// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"sensors-off"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M16.2428 16.2427C17.3286 15.1569 18.0001 13.6569 18.0001 12C18.0001 10.5388 17.4778 9.19951 16.6096 8.15881M20.4508 4.95782C22.0425 6.86577 23.0001 9.32106 23.0001 12C23.0001 15.0376 21.7689 17.7876 19.7783 19.7782M7.75796 7.75739C6.67217 8.84317 6.0006 10.3432 6.0006 12C6.0006 13.4613 6.52297 14.8005 7.39116 15.8412M4.22183 4.2218C3.3046 5.13903 2.54861 6.21748 2 7.41101C1.35799 8.80773 1 10.362 1 12C1 13.6379 1.35799 15.1922 2 16.5889C2.40805 17.4767 2.93083 18.3008 3.54935 19.0422M12.0001 13C11.4479 13 11.0001 12.5523 11.0001 12C11.0001 11.4477 11.4479 11 12.0001 11C12.5524 11 13.0001 11.4477 13.0001 12C13.0001 12.5523 12.5524 13 12.0001 13Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M21 21L3 3","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const SensorsOffIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'sensors-off',
    ref,
    icon: element,
  },
));

SensorsOffIcon.displayName = 'SensorsOffIcon';

export default SensorsOffIcon;
